<template>
  <v-app id="app">
    <UniversalNav />
    <div class="real-container-fluid">
      <router-view />
    </div>
  </v-app>
</template>

<script>
import UniversalNav from './components/structure/navigation/UniversalNav.vue';
export default {
    name: "App",
    components: { UniversalNav }
}
</script>

<style>

.nav {
  padding: 16px;
}

.router-link-exact-active {
  font-weight: 600;
  border-bottom: 3px solid #222; 
}

#app {
  height: 100%;
}

/* For some god awful reason, container--fluid is overridden by container. So I'm manually creating a fluid one */
.real-container-fluid {
  max-width: 100%;
  margin: 0 8px;
}
</style>


